import { MROReviewedCart } from "@cart-client/interfaces/MROFoodCart";
import { isMROFlow } from "@cart-client/helpers/MROFoodCart";
import { MRODeliverySectionComms, ReviewedCart } from "@swiggy-private/cart-types";

export function getDeliverySectionComms(
    cartResponse?: ReviewedCart | MROReviewedCart | null,
): MRODeliverySectionComms | undefined {
    if (!isMROFlow()) {
        return undefined;
    }
    return (cartResponse as MROReviewedCart)?.data?.delivery_section_comms;
}
